import clsx from 'clsx';
import React from 'react';
import styles from './JobStatCard.module.scss';
import { Icon } from '../../../../../icon/Icon';
import { useMemoizedDataIds } from '../../../../../shared/utils/dataId';
import { JOB_STAT_CARD_DATA_ID_CONTRACT } from './data-ids';

export interface JobStatCardProps {
  dataId: string;
  children: React.ReactNode;
  statIcon: string;
  statName: string;
  className?: string;
  statTitleClassName?: string;
  statValueClassName?: string;
}
export function JobStatCard({
  dataId,
  children,
  statIcon,
  statName,
  className = '',
  statTitleClassName = '',
  statValueClassName = ''
}: JobStatCardProps) {
  const dataIds = useMemoizedDataIds(JOB_STAT_CARD_DATA_ID_CONTRACT, dataId);

  return (
    <div className={clsx(styles.statCard, className)} data-id={dataIds.container}>
      <div
        className={clsx(styles.statName, statTitleClassName)}
        data-id={dataIds.statNameContainer}
      >
        <Icon dataId={dataIds.icon} name={statIcon} className='mr-3' />
        {statName}
      </div>

      <div data-id={dataIds.children} className={clsx(styles.statValue, statValueClassName)}>
        {children}
      </div>
    </div>
  );
}
